import { render, staticRenderFns } from "./roomCard.vue?vue&type=template&id=59ca6c50&scoped=true&"
import script from "./roomCard.vue?vue&type=script&lang=js&"
export * from "./roomCard.vue?vue&type=script&lang=js&"
import style0 from "./roomCard.vue?vue&type=style&index=0&id=59ca6c50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca6c50",
  null
  
)

export default component.exports